// extracted by mini-css-extract-plugin
module.exports = {"hiddle-ipad-portrait":"style_hiddle-ipad-portrait__6_GA7","hiddle-ipad-landscape":"style_hiddle-ipad-landscape__CeqMw"};